import { validations } from "./validations";

export const formRules = {
  first_name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  last_name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  phone: (field?: string) => [
    validations.required.text(field),
    validations.pattern.phone,
  ],
};
